export default "<app-manage-companies [dataForMyCompanies]=\"dataForMyCompanies\">\n</app-manage-companies>";